import { Button, Col, DatePicker, Form, Input, Modal, notification, Row, Select } from 'antd';
import { gatewayApi } from 'api/gatewayApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectIsDisable } from 'features/Login/authSlice';
import { gatewayActions } from 'features/User/components/GatewayInfo/gatewaySlice';
import { GatewayForm, GatewayInfo } from 'models/gateway';
import moment from 'moment';
import * as React from 'react';
import style from './Modal.module.scss';

export interface AddEditFormGatewayProps {
  isEvent: boolean;
  itemGateway: GatewayInfo | undefined;
  isModalVisible: boolean;
  setIsModalVisible: (value: boolean) => void;
  setGatewayList: (value: GatewayInfo[]) => void;
}

export default function AddEditFormGateway({
  isEvent,
  itemGateway,
  isModalVisible,
  setIsModalVisible,
  setGatewayList,
}: AddEditFormGatewayProps) {
  const [form] = Form.useForm();
  const { Option } = Select;
  const [itemGatewayInfo, setItemGatewayInfo] = React.useState<any>();
  const dispatch = useAppDispatch();
  const isDisable = useAppSelector(selectIsDisable);

  React.useEffect(() => {
    if (itemGateway !== undefined) {
      setItemGatewayInfo({
        code: formatCode(itemGateway.code),
        label: itemGateway.label,
        installation_date: moment(itemGateway.installation_date),
        location: itemGateway.location,
        serial_number: itemGateway.serial_number,
        model: itemGateway.model,
        id: itemGateway.id,
      });
    }
  }, [itemGateway]);

  const formatCode = (string: string) => {
    if (string.length <= 0) return 0;
    return string.substr(1, string.length - 1);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const handleOk = async (values: GatewayForm) => {
    try {
      if (!isEvent) {
        const gatewayItem: GatewayForm = {
          code: formatCodeItemPlant(values.code),
          label: values.label,
          installation_date:
            values.installation_date === undefined
              ? moment().valueOf()
              : Number(values.installation_date),
          location: values.location === undefined ? '' : values.location,
          serial_number: values.serial_number === undefined ? '' : values.serial_number,
          model: values.model,
        };
        await gatewayApi.add(gatewayItem);
        const res = await gatewayApi.fetchGateways({ _limit: 5, _page: 0 });
        openNotificationWithIcon('success', 'create gateway successfully');
        setGatewayList(res.data);
      } else {
        const gatewayItem: GatewayForm = {
          id: itemGateway?.id,
          code: formatCodeItemPlant(values.code),
          label: values.label,
          installation_date:
            values.installation_date === undefined ? 0 : Number(values.installation_date),
          location: values.location === undefined ? '' : values.location,
          serial_number: values.serial_number === undefined ? null : values.serial_number,
        };
        await gatewayApi.update(gatewayItem);
        await dispatch(gatewayActions.fetchGatewayInfo(itemGatewayInfo));

        const res = await gatewayApi.fetchGateways({ _limit: 5, _page: 0 });
        openNotificationWithIcon('success', 'Update gateway successfully');
        setGatewayList(res.data);
      }
    } catch (error) {
      openNotificationWithIcon('error', 'please check the data again!');
    }
    setIsModalVisible(false);
    form.resetFields();
  };

  const formatCodeItemPlant = (code: string) => {
    const count = code.length;
    let newcode;
    if (count === 1) {
      newcode = `G000${code}`;
    } else if (count === 2) {
      newcode = `G00${code}`;
    } else if (count === 3) {
      newcode = `G0${code}`;
    } else {
      newcode = `G${code}`;
    }
    return newcode;
  };

  // const [selectGateWayList, setSelectGateWayList] = React.useState([
  //   'Gateway ECU-1051-TL',
  //   'Gateway ECU-1251-TL',
  // ]);
  const selectGateWayList: string[] = ['Gateway ECU-1051-TL', 'Gateway ECU-1251-TL'];

  return (
    <Modal
      visible={isModalVisible}
      footer={
        <div className={style.footer_modal}>
          <Button onClick={handleCancel} className={style.btn_cancel}>
            Cancel
          </Button>
          <Button disabled={isDisable} onClick={() => form.submit()} className={style.btn_submit}>
            Submit
          </Button>
        </div>
      }
      width={720}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={itemGatewayInfo}
        onFinish={(values) => handleOk(values)}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="code"
              label="Code :"
              rules={[
                {
                  pattern: /^(?:\d*)$/,
                  message: 'Value should contain just number',
                },
                { required: true, message: 'Please enter Code' },
              ]}
            >
              <Input
                addonBefore="G"
                disabled={isEvent}
                maxLength={4}
                placeholder="Please enter Code"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="label"
              label="Label :"
              rules={[{ required: true, message: 'Please enter Label' }]}
            >
              <Input placeholder="Please enter Label" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name="location" label="Location :">
              <Input placeholder="Please enter location" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="model"
              label="Model :"
              rules={[{ required: true, message: 'Please enter model' }]}
            >
              <Select
                defaultValue={'--- Gateway Option ---'}
                style={{
                  marginRight: '100px',
                  textAlign: 'center',
                }}
                disabled={isEvent}
              >
                {selectGateWayList.map((itemGateWay) => (
                  <Option key={itemGateWay} value={itemGateWay}>
                    {itemGateWay}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="serial_number" label="Serial Number :">
              <Input placeholder="Please enter serial number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item name="installation_date" label="Install Date :">
              <DatePicker disabled={isEvent}/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
